import { collection, getDocs, query, limit as fsLimit } from 'firebase/firestore';
import { db } from '../../../firebase-config';
import { seedSchoolSchemaFromRegistration } from './seedSchoolSchemaFromRegistration';

/**
 * One-shot registration seed for active/paid schools missing schema docs.
 * Additive; safe to re-run (seed merges without wiping evidence extracts).
 */
export async function backfillSchoolSchemasFromRegistration(options = {}) {
  const max = Math.min(Math.max(Number(options.max) || 200, 1), 500);
  const schoolsSnap = await getDocs(query(collection(db, 'schools'), fsLimit(max)));
  const results = { attempted: 0, seeded: 0, skipped: 0, errors: [] };

  for (const schoolDoc of schoolsSnap.docs) {
    const data = schoolDoc.data() || {};
    // Prefer schools that look registered / in programme
    if (data.status === 'inactive' && !data.answers) {
      results.skipped += 1;
      continue;
    }
    results.attempted += 1;
    try {
      await seedSchoolSchemaFromRegistration(schoolDoc.id);
      results.seeded += 1;
    } catch (err) {
      results.errors.push({ schoolId: schoolDoc.id, message: err.message || String(err) });
    }
  }
  return results;
}